import React, { useState } from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import ModalCloseButton from 'components/buttons/ModalCloseButton'
import { setViewShareModal } from 'features/givingCampaigns/givingCampaignSlice'
import { baseUrl } from 'features/constants'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { BsQrCode } from "react-icons/bs";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from 'react-i18next'


export default function ShareCampaignModal() {
    const { t } = useTranslation('giving')

    const dispatch = useDispatch()
    const { viewShareModal, singleCampaignData } = useSelector(state => state.givingCampaign)
    const [isLinkCopied, setIsLinkCopied] = useState(false)   

    const handleCopyLink = () => {
        navigator.clipboard.writeText(`https://www.praysely.com/campaigns/${singleCampaignData._id}`)
        setIsLinkCopied(true)
    }

    const handleQrCode = () => {
        const canvas = document.getElementById("qrCanvas");
        if (canvas) {
          const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
      
          const downloadLink = document.createElement("a");
          downloadLink.href = pngUrl;
          downloadLink.download = `praysely-campaign-${singleCampaignData._id}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }
    }
 

    return (
        <ShareModal>
            <ModalCloseButton
                handler={
                    () => dispatch(setViewShareModal(false))
                }
                top='20px'
                right='20px'
                size='30px'
                />  

            <h1>{t('campaigns.shareCampaign')}</h1>

            <SCMain> 
                <ItemWrap>
                    <FInput> { `https://www.praysely.com/campaigns/${singleCampaignData._id}` }  </FInput> 

                    <CopyLinkButton onClick={handleCopyLink} > 
                        {
                            isLinkCopied ? 
                            (
                                 <>
                                    <AssignmentTurnedInIcon style={{marginRight: '5px'}}/>
                                    <span>{t('campaigns.linkCopied')}</span>
                                    </>
                            )
                            :
                            (
                                <>
                                    <ContentCopyIcon style={{marginRight: '5px'}}/>
                                    {t('campaigns.copyLink')}
                                </>
                            )
                        }
                    </CopyLinkButton>       
                </ItemWrap>
                 
                <ItemWrap>
                    <div style={{width: '100%', height: 'fit-content', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <QRCodeCanvas
                            id="qrCanvas"
                            value={`https://www.praysely.com/campaigns/${singleCampaignData._id}`}
                            size={200}
                            />
                    </div>
                    <QrCodeButton
                        onClick={ handleQrCode }
                        >
                        <BsQrCode size={20} style={{marginRight: '5px'}}/>
                        {t('campaigns.downloadQr')}
                    </QrCodeButton>
                </ItemWrap>
            </SCMain>
        </ShareModal>
    )
}

const ItemWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end   ;
    margin-top: 20px;
`

const QrCodeButton = styled.button`
    margin-top: 20px;
    width: 200px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--themeColor);
    color: white;
    border: none;
    border-radius: 5px; 
    cursor: pointer;
    transition: 0.3s;
    &:hover{
        background-color: var(--themeColor);
    }
`

const CopyLinkButton = styled.button`
    margin-top: 20px;
    width: 200px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--themeColor);
    color: white;
    border: none;
    border-radius: 5px; 
    cursor: pointer;
    transition: 0.3s;
    &:hover{
        background-color: var(--themeColor);
    }
`

const FInput = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: white;
    border-radius: 5px;
    padding: 10px;
    border: 1px solid #bec8ff;
    /* display an ellipsis on overflow text */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const SCMain = styled.div`

    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-radius: 10px;
    background-color: aliceblue; 
    height: fit-content;
    margin-top: 20px;
    gap: 40px;
`

const ShareModal = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 600px;
    height: fit-content;
    background-color: white;
    color: var(--lightThemeFontColor);
    border-radius: 10px;
    padding: 20px;
    h1{
        font-size: 18px;
        margin-bottom: 20px;
    }

    @media (max-width: 760px){
        width: 100%;
    }

`
